import request from "@/utils/request";

export default function getCars(id) {
    return request({
        url: `/storeOrder/agency/getCars/`+id,
        method: 'get',
    })
}
